export const environment = {
    apiUrl: 'https://api.ali.ua-drones.de',
    offerProductUrl: 'https://chromewebstore.google.com/detail/ua-dronesde/pmijhibgbgkjmmccojjkohnhigkamjkk',
    defaultCurrency: 'EUR',
    localCurrency: 'UAH',
    domainName: 'ua-drones.de',
};
